import { PageHero } from '@/components/PageHero';
import { useSeo } from '@/components/Seo';
import { LangLink, useLang } from '@/i18n/LangContext';
import sections from '@/data/collaborationAgreement.json';

export default function CollaborationAgreement() {
  const { lang } = useLang();
  useSeo({
    title: 'Accordo di collaborazione per indicatori',
    description: 'Condizioni dell’accordo di collaborazione per indicatori di Unity Consulting.',
    breadcrumbs: [{ label: 'Home', href: '/' }, { label: 'Accordo di collaborazione per indicatori' }],
  });

  return <div>
    <PageHero eyebrow="Collaborazioni" title="Accordo di collaborazione per indicatori" summary="Condizioni applicabili all’attività di segnalazione. I dati delle parti e la percentuale concordata sono riportati nel contratto individuale in PDF." breadcrumbs={[{ label: 'Home', href: '/' }, { label: 'Accordo di collaborazione per indicatori' }]} />
    <div className="container mx-auto grid max-w-6xl gap-10 px-4 py-12 lg:grid-cols-[15rem_1fr] lg:py-16">
      <nav className="hidden self-start lg:sticky lg:top-24 lg:block" aria-label="Sezioni dell’accordo">
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.16em] text-primary">Indice</p>
        <ol className="space-y-2 text-sm text-foreground/65">{sections.map((section, index) => <li key={section.title}><a className="hover:text-primary" href={`#articolo-${index + 1}`}>{index + 1}. {section.title}</a></li>)}</ol>
      </nav>
      <article className="min-w-0 space-y-10">
        <p className="rounded-xl border border-border bg-brand-pale/40 p-5 text-sm leading-relaxed text-foreground/75">Questo testo riproduce le condizioni del modello di accordo. Il contratto firmato identifica il Committente e l’Indicatore, il numero partner e la percentuale di compenso.</p>
        {sections.map((section, index) => <section key={section.title} id={`articolo-${index + 1}`} className="scroll-mt-28 border-b border-border pb-8 last:border-0">
          <h2 className="font-heading text-2xl font-bold text-foreground">{index + 1}. {section.title}</h2>
          <div className="mt-5 space-y-4 text-sm leading-7 text-foreground/80 sm:text-base">{section.blocks.map((block, blockIndex) => block.type === 'bullet'
            ? <p key={blockIndex} className="ml-5 border-l-2 border-primary/30 pl-4">{block.text}</p>
            : <p key={blockIndex}>{block.text}</p>)}</div>
        </section>)}
        <p className="text-sm text-foreground/60">Per informazioni sul proprio accordo, contattare Unity Consulting. <LangLink to="/contatti" className="font-semibold text-primary hover:underline">Contatti</LangLink></p>
        {lang === 'en' && <p className="text-xs text-foreground/50">The agreement is available in Italian.</p>}
      </article>
    </div>
  </div>;
}
